export const actions = {
    getAllOrders: "GETALLORDERS",
    getOrderItems: "GETORDERITEMS",
    getProduct: "GETPRODUCT",
    createStore: "CREATESTORE",
    getStores: "GETSTORES",
    deleteStore: "DELETESTORE",
    findOrder: "FINDORDER",
    getRtsPacking: "GETRTSPACKING",
    findProduct: "FINDPRODUCT",
    sendLabels: "SENDLABELS",
    sendLabelsStatus: "SENDLABELSSTATUS",
    holdOrder: "HOLDORDER",
    releaseOrder: "RELEASEORDER",
    getMarjanPacking: "GETMARJANPACKING",
    marjanPrep: "MARJANPREP",
    findReturn: "FINDRETURN",
    receiveReturn: "RECEIVERETURN",
    collectReturn: "COLLECTRETURN",
    setDone: "SETDONE",
    searchGroups: "SEARCHGROUPS",
    substitute: "SUBSTITUTE",
    substituteRemove: "SUBSTITUTEREMOVE",
    getCancelAlerts: "GETCANCELALERTS",
    ackCancelAlert: "ACKCANCELALERT",
    getHandoverAlerts: "GETHANDOVERALERTS",
    refreshNow: "REFRESHNOW"
}
